<template>
  <form
    @submit.prevent="handleSubmit"
    name="traveler"
    class="clearfix">
    <div class="col-md-12 mt-5">
      <!-- Subtitulo -->
      <h4 class="title-manage-account">Dados pessoais</h4>
      <!-- // Subtitulo -->
      <!-- Alert Helper -->
      <alert-helper
        :alert="error"
        type="danger"
        class="_mt-10">
      </alert-helper>
      <!-- // Alert Helper -->
    </div>

    <div class="clearfix">
      <div
        v-if="formFields.indexOf('name') > -1"
        class="col-md-12">
        <!-- Nome completo -->
        <input-field
          :submitted="submitted"
          :field.sync="form.name"
          :required="requiredFields.indexOf('name') > -1"
          label="Nome completo"
          type="text"
          name="name"
          validate="required|alpha_spaces|min:2"></input-field>
        <!-- / Nome completo -->
      </div>

      <div
        v-if="formFields.indexOf('document_number') > -1"
        class="col-md-6">
        <!-- Data de Nascimento -->
        <input-field
          :submitted="submitted"
          :field.sync="form.birthdate"
          :required="requiredFields.indexOf('birthdate') > -1"
          :mask="['##/##/####']"
          label="Data de Nascimento"
          type="text"
          name="birthdate"
          validate="required"></input-field>
        <!-- / Data de Nascimento -->
      </div>

      <div
        v-if="formFields.indexOf('birthdate') > -1"
        class="col-md-6">
        <!-- CPF -->
        <input-field
          :submitted="submitted"
          :field.sync="form.document_number"
          :required="requiredFields.indexOf('document_number') > -1"
          :mask="['###.###.###-##', '##.###.###/####-##']"
          label="CPF"
          type="text"
          name="document_number"
          validate="required"></input-field>
        <!-- / CPF -->
      </div>

      <div
        v-if="formFields.indexOf('email') > -1"
        class="col-md-6">
        <!-- E-mail -->
        <input-field
          :submitted="submitted"
          :field.sync="form.email"
          :required="requiredFields.indexOf('email') > -1"
          label="E-mail"
          type="text"
          name="email"
          validate="required|email"></input-field>
        <!-- / E-mail -->
      </div>

      <div
        v-if="formFields.indexOf('genero') > -1"
        class="col-md-3">
        <!-- Gênero -->
        <radio-field
          :submitted="submitted"
          :field.sync="form.genero"
          :required="requiredFields.indexOf('genero') > -1"
          :options="options.gender"
          label="Gênero"
          name="genero"
          validate="required|included:1,2"></radio-field>
        <!-- / Gênero -->
      </div>

      <div
        v-if="formFields.indexOf('is_active') > -1"
        class="col-md-6">
        <!-- Usuário ativo -->
        <checkbox-field
          :submitted="submitted"
          :field.sync="form.is_active"
          :required="requiredFields.indexOf('is_active') > -1"
          :value="1"
          :checked="form.is_active"
          value-label="Sim"
          label="Usuário ativo?"
          name="is_active"></checkbox-field>
        <!--/  Usuário ativo -->
      </div>
    </div>

    <div class="clearfix">
      <div class="col-md-12 mb-5 clearfix">
        <small>*Campos obrigatórios</small>
      </div>
      <div class="col-md-12 mb-20 padding-off">
        <!-- Parent Action -->
        <slot :handleParentAction="() => $emit('handleParentAction')"></slot>
        <!-- // Parent Action -->
        <div class="col-xs-6">
          <button
            :disabled="disabled"
            type="submit"
            class="btn-blue btn-block btn-extra-large">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import AlertHelper from '@/components/ui/AlertHelper'
import InputField from '@/components/fields/InputField'
import RadioField from '@/components/fields/RadioField'
import CheckboxField from '@/components/fields/CheckboxField'

export default {
  components: {
    AlertHelper,
    InputField,
    RadioField,
    CheckboxField
  },
  props: {
    requiredFields: {
      type: Array,
      default () {
        return [ 'name', 'birthdate', 'document_number', 'email', 'genero', 'is_active' ]
      }
    },
    formFields: {
      type: Array,
      default () {
        return [ 'name', 'birthdate', 'document_number', 'email', 'genero', 'is_active' ]
      }
    }
  },
  data: function() {
    return {
      form: {
        name: null,
        email: null,
        document_number: null,
        birthdate: null,
        gender: null,
        is_active: true
      },
      submitted: false,
      disabled: false,
      error: null,
      /**/
      options: {
        gender: [
          { value: 1, label: 'Masculino' },
          { value: 2, label: 'Feminino' }
        ]
      }
    }
  },
  computed: {
    ...mapState('travelers', ['loading'])
  },
  methods: {
    ...mapActions('travelers', [
      'postTraveler'
    ]),
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.disabled = true
          this.form.birthdate = moment(this.form.birthdate, 'DDMMYYYY').format('DD/MM/YYYY')

          this.postTraveler({ travelers: [ this.form ] })
            .then(this.handleParent)
            .catch(error => {
              this.disabled = false
              this.error = (error) ? error : 'Não foi possível salvar o novo viajante.'
            })
        }
      })
    },
    handleParent () {
      this.disabled = false
      if (this.$listeners && this.$listeners.handleParentAction) {
        this.$emit('handleParentAction')
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/forms/ScopedForms';
</style>
